module.exports = __webpack_public_path__ + "img/fat-lifting_hwmf10_c_scale,w_1400.5c223f6c.jpg";